import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'mibDateYear',
    standalone: false
})
export class MibYearPipe extends
    DatePipe implements PipeTransform {
    override transform(value: any, args?: any): any {
        return super.transform(value, "yyyy");
    }
}